import type {
	CreateSkuVariantDto,
	SkuVariant,
} from 'models/sku-variant/interfaces/sku-variant.interface';

export interface SkuImage {
	_id: string;
	url: string;
	name: string;
	hash: string;
	size: number;
	ext: string;
	mimeType: string;
	path: string;
	imageType: string;
}

// eslint-disable-next-line no-shadow
export enum SkuStatusEnum {
	ACTIVE = 'active',
	INACTIVE = 'inactive',
}

// eslint-disable-next-line no-shadow
export enum SkuSortType {
	createdAtNewer = '-createdAt',
	createdAtOlder = 'createdAt',
	updatedAtNewer = '-updatedAt',
	updatedAtOlder = 'updatedAt',
	codeAsc = 'code',
	codeDesc = '-code',
	priceAsc = 'minPrice',
	priceDesc = '-minPrice',
}

export interface Sku {
	_id: string;
	numericId: number;
	brand: string;
	model: string;
	brandName: string;
	brandAbbreviation: string;
	brandNumericId: number;
	modelName: string;
	modelNumericId: number;
	year: number;
	cc: number;
	version?: string;
	code: string;
	description: string;
	generalDescription?: string;
	images: SkuImage[];
	variants?: SkuVariant[];
	minPrice?: number;
	status: SkuStatusEnum;
	createdAt: string;
	updatedAt: string;
}

export interface CreateSkuDto {
	brand: string;
	model: string;
	year: number;
	cc: number;
	version?: string;
	generalDescription?: string;
	status?: SkuStatusEnum;
	variant: CreateSkuVariantDto;
}

export interface SkuFilterDto {
	brand?: string;
	model?: string;
	year?: number;
	skuCode?: string;
	status?: SkuStatusEnum;
	provider?: string;
	sort?: SkuSortType;
	searchText?: string;
	page?: number;
	limit?: number;
	requirePricedVariant?: boolean;
}
